import http from '../../services/http-common';
import securityService from '../security/security.service';

class BuyerService {
  getBuyerForList() {
    return http.get(`/buyer/db/table`);
  }
  getCompanyView() {
    return http.get(`/digitalInvoicing/getCompanyView`);
  }
  getProvincesDD(id){
    return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=${id}`);

  }
  insert(data) {
    return http.post(`/buyer/db/add`, data);
  }
  update(data) {
    return http.put(`/buyer/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/buyer/db/delete/${PropertyID}`);
  }
}

export default new BuyerService();